import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useAuth = () => {
  const navigate = useNavigate();

  const checkAuth = useCallback(async () => {
    const token = sessionStorage.getItem('nde_admin_token');
    if (!token) {
      navigate('/admin/login');
      return false;
    }

    try {
      await axios.get(`${API}/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return true;
    } catch (error) {
      sessionStorage.removeItem('nde_admin_token');
      navigate('/admin/login');
      return false;
    }
  }, [navigate]);

  const getAuthHeaders = useCallback(() => {
    const token = sessionStorage.getItem('nde_admin_token');
    return { Authorization: `Bearer ${token}` };
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem('nde_admin_token');
    navigate('/admin/login');
  }, [navigate]);

  return { checkAuth, getAuthHeaders, logout };
};

export const useBlogPosts = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogPosts = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/blog/posts?published_only=false`);
      setBlogPosts(response.data);
    } catch (error) {
      console.error('Failed to fetch blog posts:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { blogPosts, loading, fetchBlogPosts };
};
